if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
        this.personalisationInputs = this.querySelectorAll('.accordion-writing .input');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.limitIndicator();
        this.ageRestriction();
        this.letterboxGift();
        this.addSpecialTag();
        this.addExtraTouch();
        this.addExtraTouches();
        this.personaliseImage();
        this.setQuantityBoundries();
        setTimeout(this.checkVideo, 500);
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      ageRestriction() {
        let checkbox = document.getElementById('alcohol-age-restriction');
        let submit = document.querySelector('.product-form__submit');
        let personalisation = document.getElementById('personalisation');
        if (checkbox) {
          document.querySelector('.product-form__submit').disabled = true;
          checkbox.addEventListener('click', function () {
            if (checkbox.checked) {
              if (personalisation) {
                if (submit.dataset.personalisation) submit.disabled = false;
                else submit.disabled = true;
              } else {
                submit.disabled = false;
              }
            } else submit.disabled = true;
          });
        }
      }

      checkVideo() {
        let video = document.getElementById('Video');
        if (video && isNaN(video.duration)) document.getElementById('VideoThumbnail').style.display = 'none';
      }

      addExtraTouch() {
        let inputs = document.querySelectorAll('#add-an-extra-touch input[type="radio"]');
        inputs.forEach((input) => {
          input.addEventListener('change', (event) => {
            let extratouch = document.getElementById('add-an-extra-touch-prop');
            if (event.target.value) {
              extratouch.value = event.target.getAttribute('title');
              extratouch.disabled = false;
            } else {
              extratouch.value = '';
              extratouch.disabled = true;
            }
          });
        });
      }

      addExtraTouches() {
        let inputs = document.querySelectorAll('#add-extra-touches input[type="checkbox"]');
        inputs.forEach((input) => {
          input.addEventListener('change', (event) => {
            let extratouch = document.getElementById('add-extra-touches-prop');
            extratouch.value = '';
            inputs.forEach((input) => {
              if (input.checked) {
                if (extratouch.value != '') extratouch.value += ', ';
                extratouch.value += input.getAttribute('title');
                extratouch.disabled = false;
              }
            });
          });
        });
      }

      addSpecialTag() {
        let inputs = document.querySelectorAll('#add-a-tag input[type="radio"]');
        inputs.forEach((input) => {
          input.addEventListener('change', (event) => {
            let specialtag = document.getElementById('add-a-special-tag');
            if (event.target.value) {
              specialtag.value = event.target.getAttribute('title');
              specialtag.disabled = false;
            } else {
              specialtag.value = '';
              specialtag.disabled = true;
            }
          });
        });
      }

      personaliseImage() {
        var username = '01M4EV';
        var key =
          '2A9E82ABECE1B5853DB32AB6ADB3EBA19D3E2F6146438B7B481618DDA91DEBB873573B69333DC406932078A646462C60DEB1386ABC81C34842B8CEE4753F5413';
        var sku = document.getElementById('product__sku').innerHTML;
        var modal = document.getElementById('PopupModal-personalisation');
        var inputs = document.querySelectorAll('#personalisation [type="text"]');
        var preview = document.getElementById('preview');
        if (preview) {
          preview.addEventListener('click', function () {
            var pers = '';
            inputs.forEach((input) => {
              if (input.value != '') {
                if (pers != '') pers += ';';
                pers += input.getAttribute('title') + '=' + input.value;
              }
            });
            var tohash = 'set' + sku + 'tPers{$' + pers + '$}pw600co80u' + username + key;
            var seal = CryptoJS.MD5(tohash);
            var imageUrl =
              'https://preview.personalisedmemento.co.uk/dsmo/streamimage.aspx?set=' +
              sku +
              '&t=Pers%7b%24' +
              encodeURIComponent(pers) +
              '%24%7d&pw=600&co=80&u=' +
              username +
              '&Seal=' +
              seal;
            modal.querySelector('img').setAttribute('src', imageUrl);
            modal.show();
          });
        }
      }

      letterboxGift() {
        let inputs = document.querySelectorAll('#upgrade-to-a-letterbox-gift input[type="checkbox"]');
        inputs.forEach((input) => {
          input.addEventListener('change', (event) => {
            if (event.target.checked) event.target.previousElementSibling.disabled = false;
            else event.target.previousElementSibling.disabled = true;
            let letterbox = document.getElementById('letterbox');
            letterbox.value = 0;
            inputs.forEach((checkbox) => {
              if (checkbox.checked) letterbox.value = 47987097698588;
            });
          });
        });
      }

      limitIndicator() {
        let personalisationInputs = this.personalisationInputs;
        personalisationInputs.forEach(function (element) {
          let input = element.querySelector('input');
          let maxlength = input.getAttribute('maxlength');
          let submit = document.querySelector('.product-form__submit');
          let alcoholCheckbox = document.getElementById('alcohol-age-restriction');
          if (maxlength) {
            let indicatorValue = element.querySelector('.indicator strong');
            input.addEventListener('keyup', function () {
              let totalCharacters = 0;
              input.value = input.value.replace(/[^a-zA-Z0-9!&\s'\?_\-,\.="]/g, '');
              let remaining = maxlength - this.value.length;
              indicatorValue.innerHTML = remaining;
              personalisationInputs.forEach(function (element) {
                let input = element.querySelector('input');
                totalCharacters += input.value.length;
              });
              if (totalCharacters > 0) {
                if (document.getElementById('handwriting')) {
                  document.getElementById('handwriting').value = 47636130431260;
                  if (document.getElementById('accordion-upgrade-to-a-letterbox-gift'))
                    document.getElementById('accordion-upgrade-to-a-letterbox-gift').style.display = 'block';
                }
                if (document.getElementById('giftwrap')) document.getElementById('giftwrap').value = 47636085899548;
                if (document.getElementById('personalisation')) {
                  submit.dataset.personalisation = 'true';
                  if (alcoholCheckbox) {
                    if (alcoholCheckbox.checked) submit.disabled = false;
                    else submit.disabled = true;
                  } else {
                    submit.disabled = false;
                  }
                }
              } else {
                if (document.getElementById('handwriting')) {
                  document.getElementById('handwriting').value = 0;
                  if (document.getElementById('accordion-upgrade-to-a-letterbox-gift'))
                    document.getElementById('accordion-upgrade-to-a-letterbox-gift').style.display = 'none';
                }
                if (document.getElementById('giftwrap')) document.getElementById('giftwrap').value = 0;
                if (document.getElementById('personalisation')) {
                  submit.dataset.personalisation = '';
                  submit.disabled = true;
                }
              }
            });
          }
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
